import React, { useEffect, useMemo, useState } from 'react';
import { Table, Button, FormInput, ColumnProps, Form, Row, Col, FormResetButton } from '@digital/ui';
import { CrfCicloOrcamentarioRelatorio, CrfCicloOrcamentarioRelatorioResult } from '@app/api/crf/CrfRelatorioCicloorcamentario';
import { compareNumber, compareText } from '@app/helpers/comparators';
import { Icon, Tooltip } from 'antd';
import { PaginationConfig } from 'antd/lib/pagination';
import { formatCurrencyBr } from '@app/helpers/numbers';

interface TableCicloOrcamentarioPluriAnualProps {
  cicloOrcamentarioRelatorioTotal: CrfCicloOrcamentarioRelatorio;
  paginacaoConfig: PaginationConfig,
  relatorioControleRfa?: boolean,
  ocultarColunaDetalhe: boolean,
  mostrarColunaDetalheFechamento?: boolean,
  fechamentoId?: string;
}

const TableCicloOrcamentarioPluriAnual = (props: TableCicloOrcamentarioPluriAnualProps) => {
  const { cicloOrcamentarioRelatorioTotal, paginacaoConfig, relatorioControleRfa, ocultarColunaDetalhe, mostrarColunaDetalheFechamento, fechamentoId } = props;


  const [valorTotalA, setValorTotalA] = useState(cicloOrcamentarioRelatorioTotal.valorTotalA);
  const [valorTotalB, setValorTotalB] = useState(cicloOrcamentarioRelatorioTotal.valorTotalB);
  const [valorTotalC, setValorTotalC] = useState(cicloOrcamentarioRelatorioTotal.valorTotalC);
  const [valorTotalD, setValorTotalD] = useState(cicloOrcamentarioRelatorioTotal.valorTotalD);
  const [valorTotalE, setValorTotalE] = useState(cicloOrcamentarioRelatorioTotal.valorTotalE);
  const [valorTotalF, setValorTotalF] = useState(cicloOrcamentarioRelatorioTotal.valorTotalF);
  const [valorTotalG, setValorTotalG] = useState(cicloOrcamentarioRelatorioTotal.valorTotalG);
  const [valorTotalH, setValorTotalH] = useState(cicloOrcamentarioRelatorioTotal.valorTotalH);
  const [valorTotalI, setValorTotalI] = useState(cicloOrcamentarioRelatorioTotal.valorTotalI);
  const [valorTotalJ, setValorTotalJ] = useState(cicloOrcamentarioRelatorioTotal.valorTotalJ);


  useMemo(() => {
    paginacaoConfig.onChange = (() => {
      document.getElementById("tableCicloOrcamentarioPluriAnual").scrollIntoView();
    })
  }, [paginacaoConfig]);


  const colunas = useMemo(() => {
    if (cicloOrcamentarioRelatorioTotal) {
      let colluns: ColumnProps<CrfCicloOrcamentarioRelatorioResult>[] = new Array();

      colluns.push(
        {
          title: 'N',
          dataIndex: 'numeroLinha',
          sorter: (a, b) => compareNumber(a.numeroLinha, b.numeroLinha),
        });


      colluns.push({
        title: 'CÓD. PROJETO',
        dataIndex: 'codProjeto',
        sorter: (a, b) => compareText(a.codProjeto, b.codProjeto),
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <Form>
            <Row>
              <FormInput
                placeholder="Pesquisar CÓD. PROJETO"
                name="codProjeto"
                style={{ marginTop: '15px' }}
                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                onPressEnter={() => {
                  if (typeof confirm === 'function') confirm();
                }}
              />
            </Row>
            <Row>
              <Col span={6}>
                <Button
                  type="primary"
                  style={{ marginLeft: '5px' }}
                  onClick={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                  icon="commons-search"
                  size="small">
                  Pesquisar
                </Button>
              </Col>
              <Col span={6}>
                <FormResetButton
                  size="small"
                  style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                  beforeReset={() => {
                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                  }}>
                  Limpar
                </FormResetButton>
              </Col>
            </Row>
          </Form>
        ),
        filterIcon: filtered => {
          const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
          return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
        },
        onFilter: (value, record) =>
          record.codProjeto !== undefined &&
          record.codProjeto
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
      });


      colluns.push({
        title: 'NOME DO PROJETO',
        dataIndex: 'nomeprojeto',
        sorter: (a, b) => compareText(a.nomeprojeto, b.nomeprojeto),
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <Form>
            <Row>
              <FormInput
                placeholder="Pesquisar CÓD. PROJETO"
                name="codProjeto"
                style={{ marginTop: '15px' }}
                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                onPressEnter={() => {
                  if (typeof confirm === 'function') confirm();
                }}
              />
            </Row>
            <Row>
              <Col span={6}>
                <Button
                  type="primary"
                  style={{ marginLeft: '5px' }}
                  onClick={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                  icon="commons-search"
                  size="small">
                  Pesquisar
                </Button>
              </Col>
              <Col span={6}>
                <FormResetButton
                  size="small"
                  style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                  beforeReset={() => {
                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                  }}>
                  Limpar
                </FormResetButton>
              </Col>
            </Row>
          </Form>
        ),
        filterIcon: filtered => {
          const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
          return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
        },
        onFilter: (value, record) =>
          record.nomeprojeto !== undefined &&
          record.nomeprojeto
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
      });

      if (relatorioControleRfa === false || relatorioControleRfa === undefined) {
        colluns.push(
          {
            title: 'Dir',
            dataIndex: 'diretoria',
            render: (text, row, index) => {
              return <>
                <Tooltip title={row.diretoriaNome}>
                  <span>{row.diretoria}</span>
                </Tooltip>
              </>
            },
            sorter: (a, b) => compareText(a.diretoria, b.diretoria),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
              <Form>
                <Row>
                  <FormInput
                    placeholder="Pesquisar CÓD. PROJETO"
                    name="diretoria"
                    style={{ marginTop: '15px' }}
                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                    onPressEnter={() => {
                      if (typeof confirm === 'function') confirm();
                    }}
                  />
                </Row>
                <Row>
                  <Col span={6}>
                    <Button
                      type="primary"
                      style={{ marginLeft: '5px' }}
                      onClick={() => {
                        if (typeof confirm === 'function') confirm();
                      }}
                      icon="commons-search"
                      size="small">
                      Pesquisar
                    </Button>
                  </Col>
                  <Col span={6}>
                    <FormResetButton
                      size="small"
                      style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                      beforeReset={() => {
                        if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                      }}>
                      Limpar
                    </FormResetButton>
                  </Col>
                </Row>
              </Form>
            ),
            filterIcon: filtered => {
              const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
              return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
              record.diretoria !== undefined &&
              record.diretoria !== null &&
              record.diretoria
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
          },
          {
            title: 'ÁREA',
            dataIndex: 'area',
            render: (text, row, index) => {
              return <>
                <Tooltip title={row.areaNome}>
                  <span>{row.area}</span>
                </Tooltip>
              </>
            },
            sorter: (a, b) => compareText(a.area, b.area),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
              <Form>
                <Row>
                  <FormInput
                    placeholder="Pesquisar"
                    name="area"
                    style={{ marginTop: '15px' }}
                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                    onPressEnter={() => {
                      if (typeof confirm === 'function') confirm();
                    }}
                  />
                </Row>
                <Row>
                  <Col span={6}>
                    <Button
                      type="primary"
                      style={{ marginLeft: '5px' }}
                      onClick={() => {
                        if (typeof confirm === 'function') confirm();
                      }}
                      icon="commons-search"
                      size="small">
                      Pesquisar
                    </Button>
                  </Col>
                  <Col span={6}>
                    <FormResetButton
                      size="small"
                      style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                      beforeReset={() => {
                        if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                      }}>
                      Limpar
                    </FormResetButton>
                  </Col>
                </Row>
              </Form>
            ),
            filterIcon: filtered => {
              const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
              return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) => {
              try {
                if (record != undefined
                  && record.hasOwnProperty('area')
                  && record.area != null) {
                  return record.area.toLowerCase() == value.toLowerCase()
                }
              } catch (e) {
                // console.log(e);
              }
              return false;
            }
          },
          {
            title: 'Dep',
            dataIndex: 'departamento',
            render: (text, row, index) => {
              return <>
                <Tooltip title={row.departamentoNome}>
                  <span>{row.departamento}</span>
                </Tooltip>
              </>
            },
            sorter: (a, b) => compareText(a.departamento, b.departamento),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
              <Form>
                <Row>
                  <FormInput
                    placeholder="Pesquisar"
                    name="departamento"
                    style={{ marginTop: '15px' }}
                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                    onPressEnter={() => {
                      if (typeof confirm === 'function') confirm();
                    }}
                  />
                </Row>
                <Row>
                  <Col span={6}>
                    <Button
                      type="primary"
                      style={{ marginLeft: '5px' }}
                      onClick={() => {
                        if (typeof confirm === 'function') confirm();
                      }}
                      icon="commons-search"
                      size="small">
                      Pesquisar
                    </Button>
                  </Col>
                  <Col span={6}>
                    <FormResetButton
                      size="small"
                      style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                      beforeReset={() => {
                        if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                      }}>
                      Limpar
                    </FormResetButton>
                  </Col>
                </Row>
              </Form>
            ),
            filterIcon: filtered => {
              const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
              return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) => {
              try {
                if (record != undefined
                  && record.hasOwnProperty('departamento')
                  && record.departamento != null) {
                  return record.departamento.toLowerCase() == value.toLowerCase()
                }
              } catch (e) {
                // console.log(e);
              }
              return false;
            }
          },
        );
      }

      if (relatorioControleRfa === true) {
        colluns.push({
          title: 'CONTROLE RFA',
          dataIndex: 'planilhaRfaAtual',
          sorter: (a, b) => compareText(a.planilhaRfaAtual, b.planilhaRfaAtual),
          filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <Form>
              <Row>
                <FormInput
                  placeholder="Pesquisar CONTROLE RFA"
                  name="planilhaRfaAtual"
                  style={{ marginTop: '15px' }}
                  onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                  onPressEnter={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                />
              </Row>
              <Row>
                <Col span={6}>
                  <Button
                    type="primary"
                    style={{ marginLeft: '5px' }}
                    onClick={() => {
                      if (typeof confirm === 'function') confirm();
                    }}
                    icon="commons-search"
                    size="small">
                    Pesquisar
                  </Button>
                </Col>
                <Col span={6}>
                  <FormResetButton
                    size="small"
                    style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                    beforeReset={() => {
                      if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                    }}>
                    Limpar
                  </FormResetButton>
                </Col>
              </Row>
            </Form>
          ),
          filterIcon: filtered => {
            const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
            return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
          },
          onFilter: (value, record) =>
            record.planilhaRfaAtual !== undefined &&
            record.planilhaRfaAtual
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase()),
        });
      }

      colluns.push({
        dataIndex: 'totalizadorColunaA',
        align: 'center',
        title: (column) => {
          return <div id={'ColunaTotalizadorColunaA'}> {valorTotalA}</div>
        },
        children: [
          {
            title: 'A',
            children: [
              {
                title: 'orçado',
                dataIndex: 'capEx',
                align: 'center',
              },
            ],
          },
        ],
      });


      colluns.push({
        dataIndex: 'totalizadorColunaB',
        align: 'center',
        title: (column) => {
          return <div id={'ColunaTotalizadorColunaB'}> {valorTotalB}</div>
        },
        children: [
          {
            title: 'B',
            children: [
              {
                title: 'Contratado',
                dataIndex: 'contratado',
                align: 'center',
              },
            ],
          },
        ],
      });

      colluns.push({
        dataIndex: 'totalizadorColunaC',
        align: 'center',
        title: (column) => {
          return <div id={'ColunaTotalizadorColunaC'}> {valorTotalC}</div>
        },
        children: [
          {
            title: 'C',
            children: [
              {
                title: 'Executado',
                dataIndex: 'executado',
                align: 'center',
              },
            ],
          },
        ],
      });


      colluns.push({
        dataIndex: 'totalizadorColunad',
        align: 'center',
        title: (column) => {
          return <div id={'ColunaTotalizadorColunaD'}> {valorTotalD}</div>
        },
        children: [
          {
            title: 'D',
            children: [
              {
                title: 'Requisitado',
                dataIndex: 'requisitado',
                align: 'center',
              },
            ],
          },
        ],
      });

      colluns.push({
        dataIndex: 'totalizadorColunaEbcd',
        align: 'center',
        title: (column) => {
          return <div id={'ColunaTotalizadorColunaE'}> {valorTotalE}</div>
        },
        children: [
          {
            title: 'e = b - c + d',
            children: [
              {
                title: 'Compromissado',
                dataIndex: 'compromissado',
                align: 'center',
              },
            ],
          },
        ],
      });


      colluns.push({
        dataIndex: 'totalizadorColunaF',
        align: 'center',
        title: (column) => {
          return <div id={'ColunaTotalizadorColunaF'}> {valorTotalF}</div>
        },
        children: [
          {
            title: 'F',
            children: [
              {
                title: 'A Contratar',
                dataIndex: 'aContratar',
                align: 'center',
              },
            ],
          },
        ],
      });

      colluns.push({
        dataIndex: 'totalizadorColunaGbdff',
        align: 'center',
        title: (column) => {
          return <div id={'ColunaTotalizadorColunaG'}> {valorTotalG}</div>
        },
        children: [
          {
            title: 'g = b + d + f',
            children: [
              {
                title: 'Forecast',
                dataIndex: 'forecast',
                align: 'center',
              },
            ],
          },
        ],
      });


      colluns.push({
        dataIndex: 'totalizadorColunahag',
        align: 'center',
        title: (column) => {
          return <div id={'ColunaTotalizadorColunaH'}> {valorTotalH}</div>
        },
        children: [
          {
            title: 'h = a - g',
            children: [
              {
                title: 'variação',
                dataIndex: 'saldoCapEx',
                align: 'center',
              },
              {
                title: '%',
                dataIndex: 'saldoCapExPercentual',
                align: 'center',
                sorter: (a, b) => compareText(a.saldoCapExPercentual, b.saldoCapExPercentual),
              },
              {
                title: '',
                dataIndex: 'saldoCapExPercentual',
                align: 'center',
                render: (text, row, index) => {
                  return <> <Icon type="check-circle" theme="twoTone" twoToneColor={row.saldoCapExPercentualCor} /> </>
                },
              },
            ],
          },
        ],
      });


      if (relatorioControleRfa === true) {

        colluns.push({
          dataIndex: 'totalizadorColunaI',
          align: 'center',
          title: (column) => {
            return <div id={'ColunaTotalizadorColunaI'}> {valorTotalI}</div>
          },
          children: [
            {
              title: 'I',
              children: [
                {
                  title: 'Orçado Ano',
                  dataIndex: 'capexCicloAno',
                  align: 'center',
                },
              ],
            },
          ],
        });

        colluns.push({
          dataIndex: 'totalizadorColunaJ',
          align: 'center',
          title: (column) => {
            return <div id={'ColunaTotalizadorColunaJ'}> {valorTotalJ}</div>
          },
          children: [
            {
              title: 'J',
              children: [
                {
                  title: 'Forecast Ano',
                  dataIndex: 'forecastCicloAno',
                  align: 'center',
                },
              ],
            },
          ],
        });
      }

      if (ocultarColunaDetalhe === false) {
        colluns.push({
          title: `Detalhe`,
          align: 'center',
          render: (text, row, index) => {
            return (
              <>
                <Button
                  onClick={() => {
                    window.open(`/Cr/relatorios/CrfRelatorioProjetoPluriAnualDetalheProjeto/dadosgerais?projetoId=${row.id}`);
                  }}
                  icon="commons-search"
                />
              </>
            );
          },
        });
      }

      if (mostrarColunaDetalheFechamento === true) {
        colluns.push({
          title: `Detalhe`,
          align: 'center',
          render: (text, row, index) => {
            return (
              <>
                <Button
                  onClick={() => {
                    window.open(`/Cr/detalheProjetoFechamento/dadosGerais?fechamentoId=${fechamentoId}&projetoId=${row.id}`);
                  }}
                  icon="commons-search"
                />
              </>
            );
          },
        });
      }
      return colluns;
    }
    return [];
  }, [
    cicloOrcamentarioRelatorioTotal,
    valorTotalA,
    valorTotalB,
    valorTotalC,
    valorTotalD,
    valorTotalE,
    valorTotalF,
    valorTotalG,
    valorTotalH,
    valorTotalI,
    valorTotalJ,
  ]);


  useEffect(() => {
    if (cicloOrcamentarioRelatorioTotal && cicloOrcamentarioRelatorioTotal.result) {
      calcularTotalColunasAoIniciar();
    }
  }, []);

  const calcularTotalColunasAoIniciar = () => {
    let totalA = 0;
    let totalB = 0;
    let totalC = 0;
    let totalD = 0;
    let totalE = 0;
    let totalF = 0;
    let totalG = 0;
    let totalH = 0;

    cicloOrcamentarioRelatorioTotal.result.map((item) => {
      totalA += item.capExDecimal;
      totalB += item.contratadoDecimal;
      totalC += item.executadoDecimal;
      totalD += item.requisitadoDecimal;
      totalE += item.compromissadoDecimal;
      totalF += item.aContratarDecimal;
      totalG += item.forecastDecimal;
      totalH += item.saldoCapExDecimal;
    });

    setValorTotalA(formatCurrencyBr(totalA));
    setValorTotalB(formatCurrencyBr(totalB));
    setValorTotalC(formatCurrencyBr(totalC));
    setValorTotalD(formatCurrencyBr(totalD));
    setValorTotalE(formatCurrencyBr(totalE));
    setValorTotalF(formatCurrencyBr(totalF));
    setValorTotalG(formatCurrencyBr(totalG));
    setValorTotalH(formatCurrencyBr(totalH));
  }


  const calcularCabecalhoDaTabela = (extra: TableCurrentDataSource<CrfCicloOrcamentarioRelatorioResult>) => {
    let totalA = 0;
    let totalB = 0;
    let totalC = 0;
    let totalD = 0;
    let totalE = 0;
    let totalF = 0;
    let totalG = 0;
    let totalH = 0;
    let totalI = 0;
    let totalJ = 0;

    extra.currentDataSource.map((item) => {
      totalA += item.capExDecimal;
      totalB += item.contratadoDecimal;
      totalC += item.executadoDecimal;
      totalD += item.requisitadoDecimal;
      totalE += item.compromissadoDecimal;
      totalF += item.aContratarDecimal;
      totalG += item.forecastDecimal;
      totalH += item.saldoCapExDecimal;
      totalI += item.capexCicloAnoRfaDecimal;
      totalJ += item.forecastCicloAnoRfaDecimal;
    });


    setValorTotalA(formatCurrencyBr(totalA));
    setValorTotalB(formatCurrencyBr(totalB));
    setValorTotalC(formatCurrencyBr(totalC));
    setValorTotalD(formatCurrencyBr(totalD));
    setValorTotalE(formatCurrencyBr(totalE));
    setValorTotalF(formatCurrencyBr(totalF));
    setValorTotalG(formatCurrencyBr(totalG));
    setValorTotalH(formatCurrencyBr(totalH));
    setValorTotalI(formatCurrencyBr(totalI));
    setValorTotalJ(formatCurrencyBr(totalJ));

  }


  return <Table
    rowKey="id"
    id="tableCicloOrcamentarioPluriAnual"
    columns={colunas}
    dataSource={cicloOrcamentarioRelatorioTotal.result}
    pagination={paginacaoConfig}
    onChange={(pagination, filters, sorter, extra) => {
      calcularCabecalhoDaTabela(extra);
    }}
  />;
};

export default TableCicloOrcamentarioPluriAnual;
